import { SchemaScript } from "./SchemaScript"

export const SITE_URL = "https://tokenterminal.com"

// Stable ids, so other schemas can refer to Token Terminal, e.g. `publisher: { "@id": ORGANIZATION_ID }`
export const ORGANIZATION_ID = `${SITE_URL}/#organization`
const WEBSITE_ID = `${SITE_URL}/#website`

/** Token Terminal in another schema, e.g. `publisher: ORGANIZATION_REF`. The name is for parsers that do not follow the `@id`. */
export const ORGANIZATION_REF = {
  "@type": "Organization",
  "@id": ORGANIZATION_ID,
  name: "Token Terminal",
}

const organizationSchema = {
  "@context": "https://schema.org",
  ...ORGANIZATION_REF,
  url: SITE_URL,
  logo: `${SITE_URL}/android-chrome-512x512.png`,
  sameAs: [
    "https://x.com/tokenterminal",
    "https://www.linkedin.com/company/token-terminal",
    "https://github.com/token-terminal",
    "https://www.youtube.com/tokenterminal",
    "https://discord.com/invite/tokenterminal",
  ],
}

// No SearchAction: the only search URL (/explorer/discover?search=) is noindex
const websiteSchema = {
  "@context": "https://schema.org",
  "@type": "WebSite",
  "@id": WEBSITE_ID,
  name: "Token Terminal",
  url: SITE_URL,
  publisher: { "@id": ORGANIZATION_ID },
}

/** Organization and WebSite JSON-LD for Token Terminal. Render once in each app's `_app`. */
export const SiteSchemas = () => (
  <>
    <SchemaScript id="site-organization" schema={organizationSchema} />
    <SchemaScript id="site-website" schema={websiteSchema} />
  </>
)
